// GET READER CLUB
export const GET_READER_CLUB_DATA = 'GET_READER_CLUB_DATA';
export const GET_READER_CLUB_SUCCESS = 'GET_READER_CLUB_SUCCESS';
export const GET_READER_CLUB_FAILURE = 'GET_READER_CLUB_FAILURE';
// POST READER CLUB
export const POST_READER_CLUB_DATA = 'POST_READER_CLUB_DATA';
export const POST_READER_CLUB_SUCCESS = 'POST_READER_CLUB_SUCCESS';
export const POST_READER_CLUB_FAILURE = 'POST_READER_CLUB_FAILURE';
export const SAVE_PLAN_ID = 'SAVE_PLAN_ID';